import { useContext, useState } from "react";
import { LocaleContext } from "../../../../routing/LangRouter";
import { Grid } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//import general components
import QuestionModal from "../../../common/question-modal/question-modal";

//import styles
import "./panel-menu.scss";

//import images and icons
import ordersIconActive from "../../../../assets/imgs/Myorders3.png";
import ordersIconInactive from "../../../../assets/imgs/Myorders2.png";
import smartReservationActive from "../../../../assets/icons/smart-reservation-white.svg";
import smartReservationInactive from "../../../../assets/icons/smart-reservation.svg";
import { Call, EmptyWallet, Like, LogoutCurve, Map1, Profile, Profile2User, ProfileDelete, ShoppingBag, UserAdd, Wallet2 } from "iconsax-react";

function PanelMenu() {
    //general
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const location = useLocation();
    const { t } = useTranslation();

    const menuList = [
        {
            label: t("userAccount"),
            to: "user-account",
            icon: <Profile color="var(--teal-color-18)" />,
            activeIcon: <Profile color="var(--light-color)" variant="Bold" />,
            disabled: false,
        },
        {
            label: t("User Panel.myOrders"),
            to: "orders",
            icon: <img src={ordersIconInactive} />,
            activeIcon: <img src={ordersIconActive} />,
            disabled: false,
        },
        {
            label: "معرفی دوستان",
            to: "friends-introduction",
            icon: <UserAdd color="var(--teal-color-18)" />,
            activeIcon: <UserAdd color="var(--light-color)" variant="Bold" />,
            disabled: false,
        },
        {
            label: t("myItineraries"),
            to: "my-itinerary",
            icon: <Map1 color="var(--teal-color-18)" />,
            activeIcon: <Map1 color="var(--light-color)" variant="Bold" />,
            disabled: false,
        },
        {
            label: t("myTours"),
            to: "my-tours",
            icon: <ShoppingBag color="var(--teal-color-18)" />,
            activeIcon: <ShoppingBag color="var(--light-color)" variant="Bold" />,
            disabled: false,
        },
        {
            label: t("myFellowTravelers"),
            to: "passenger",
            icon: <Profile2User color="var(--teal-color-18)" />,
            activeIcon: <Profile2User color="var(--light-color)" variant="Bold" />,
            disabled: false,
        },
        {
            label: t("wallet"),
            to: "wallet",
            icon: <Wallet2 color="var(--teal-color-18)" />,
            activeIcon: <EmptyWallet color="var(--light-color)" variant="Bold" />,
            disabled: true,
        },
        {
            label: t("User Panel.smartReservation"),
            to: "smart-reservation",
            icon: <img src={smartReservationInactive} />,
            activeIcon: <img src={smartReservationActive} />,
            disabled: true,
        },
        {
            label: t("favorites"),
            to: "user-favorites",
            icon: <Like color="var(--teal-color-18)" />,
            activeIcon: <Like color="var(--light-color)" variant="Bold" />,
            disabled: true,
        },
        {
            label: t("support"),
            to: "support",
            icon: <Call color="var(--teal-color-18)" />,
            activeIcon: <Call color="var(--light-color)" variant="Bold" />,
            disabled: true,
        },
        {
            label: t("deleteAccount"),
            to: "delete-account",
            icon: <ProfileDelete color="var(--teal-color-18)" />,
            activeIcon: <ProfileDelete color="var(--light-color)" variant="Bold" />,
            disabled: true,
        },
    ];

    //logout user
    const [open, setOpen] = useState(false);
    const logout = () => {
        localStorage.clear();
        navigate(`/${locale}`);
    };

    return (
        <Grid className="panel-menu" container item xs={12} lg={2} rowGap={2} mb={{ xs: 2, md: 0 }}>
            <ul className="panel-menu__menu-list">
                {menuList.map((menuItem, index) => {
                    return (
                        <li
                            key={index}
                            className={`panel-menu__menu-item ${location.pathname === `/${locale}/user-panel/${menuItem.to}` ? "active" : ""}`}
                        >
                            <Link
                                className={`panel-menu__menu-link ${
                                    location.pathname === `/${locale}/user-panel/${menuItem.to}` ? "active-link" : ""
                                }`}
                                to={menuItem.to}
                            >
                                {location.pathname === `/${locale}/user-panel/${menuItem.to}` ? menuItem.activeIcon : menuItem.icon}
                                {menuItem.label}
                            </Link>
                        </li>
                    );
                })}
            </ul>
            <Grid
                className="panel-menu__logout"
                container
                item
                xs={12}
                columnGap={2}
                alignItems="center"
                display={{ xs: "flex", md: "none" }}
                onClick={() => setOpen(true)}
            >
                <LogoutCurve color="var(--red-color)" /> {t("User Panel.Logout")}
            </Grid>
            <QuestionModal open={open} setOpen={setOpen} question={t("areYouSure")} colorYes="blue-gray" colorNo="teal-18" handleClick={logout} />
        </Grid>
    );
}

export default PanelMenu;
